module.exports = __webpack_public_path__ + "bff5ca4b51d1f466f6e550d5b42e2c1e.svg";


//////////////////
// WEBPACK FOOTER
// ./images/share-white.svg
// module id = 68
// module chunks = 0